// extracted by mini-css-extract-plugin
export default {"main":"imageOrNoPhoto_main__josTi","cover":"imageOrNoPhoto_cover__KDbDJ","contain":"imageOrNoPhoto_contain__uJ+1K"};